require ('jquery');
require('@fancyapps/fancybox');


$(document).ready( function () {

    $('[data-fancybox]').fancybox({
        loop : true,
        //width: 200,
        height: 870,
        autoSize: false,
        scrolling: false
    });

    $(document).on('click', '[data-fancybox="gallery"]', function(event) {
        event.preventDefault();
    });

});



// WEBPACK FOOTER //
// ./resources/js/lightbox.js